<template>
  <div :class="[loader.isLoading ? 'fixed' : 'hidden', 'flex justify-center items-center h-full w-full top-0 left-0 z-[1000]']">
    <div class="loader animate-spin rounded-[20px] h-12 w-12 border-t-4 border-b-4"></div>
  </div>
</template>

<script setup>
import { useLoaderStore } from "~/stores/loader.js";

const loader = useLoaderStore();
</script>

<style lang="scss" scoped>

$_primary-color: #3f4759;
$_secondary-color: #27e9af;
$_tertiary-color: #ececec;


.loader {
  border-color: $_secondary-color;
}
</style>
